import React, {Fragment, useRef} from 'react';
import Helmet from 'react-helmet';
import Layout from '@layouts';
import Section from '@components/layout/Section';
import Hero from '@components/Hero';
import VideoCallout from '@components/VideoCallout';
import VirtualTourCopy from '@components/VirtualTourCopy';
import PreFooter from '@components/PreFooter';
import {WHITE} from '@styles/colors';

const mediaQueries = {
  sm: 'screen and (max-width: 1024px)',
  lg: 'screen and (min-width: 1280px)',
};

export default () => {
  const sectionRef = useRef(null);

  const heroImage = {
    url:
      'https://www-fetner-com-production.s3.amazonaws.com/media/images/virtualtourshero.original.jpg',
    copy: 'somewords',
  };

  return (
    <Fragment>
      <Helmet>
        <html lang="en" />
        <title>{'Virtual Property Tours'}</title>
        <meta name="description" content={'Virtual Tour'} />
      </Helmet>
      <Layout>
        <Hero
          title={'Take a Virtual Tour'}
          background={`linear-gradient(rgba(20, 20, 20, 0.3), rgba(20, 20, 20, 0.3)), url(${heroImage.url})`}
          body={
            'We always have you in mind, so to give you peace of mind, check out your new home from home.'
          }
          scrollToLink
          copy={'Look Around'}
          sectionRef={sectionRef}
        />

        <div id="second-section" ref={sectionRef}>
          <Section key={0} /*sectionRef={0}*/>
            <VideoCallout
              background={WHITE}
              videoWidth={'50%'}
              sectionCopyWidth={'35%'}
              mediaQueries={mediaQueries}
              smFlexDirection={'column-reverse !important'}
              videoId={'hZBt-0efkgo'}
              headline={'Tour The Epic'}
              textTransform={'none'}
              imageLeft
            >
              <VirtualTourCopy
                address={'125 WEST 31ST ST, NEW YORK, NY, 10001'}
                phone={'212-554-2700'}
                caption={
                  'Take a virtual tour of our available units and amenity spaces below:'
                }
                links={[
                  {
                    url: 'https://my.matterport.com/show/?m=XTDHZXmh9Mv',
                    label: 'The Epic A Line (2BR/2BA)',
                  },
                  {
                    url: 'https://my.matterport.com/show/?m=p8gKi3xACmy',
                    label: 'The Epic C Line (1br/1ba)',
                  },
                  {
                    url: 'https://my.matterport.com/show/?m=yqahNtcHU5y',
                    label: 'The Epic D Line (1br/1ba)',
                  },
                  {
                    url: 'https://my.matterport.com/show/?m=JMGLX2q6MTR',
                    label: 'The Epic E Line (1br/1ba)',
                  },
                  {
                    url: 'https://my.matterport.com/show/?m=XtohhTS4zxo',
                    label: 'The Epic G Line (2br/2ba)',
                  },
                  {
                    url: 'https://my.matterport.com/show/?m=JutGUb41Qy1',
                    label: 'The Epic K Line (1 BR/1BA)',
                  },
                  {
                    url: 'https://my.matterport.com/show/?m=wHFEHGkLWHX',
                    label: 'Fitness Center',
                  },
                  {
                    url: 'https://my.matterport.com/show/?m=GAdscp6Wncz',
                    label: 'Basketball Court',
                  },
                ]}
              />
            </VideoCallout>
          </Section>
        </div>

        {/* <PreFooter /> */}
      </Layout>
    </Fragment>
  );
};
